import { Grid, Button } from "@mui/material";
import AddProfileButton from "../add-profile/AddProfileButton";
import PerformanceScreenButton from "../performance-overview/PerformanceScreenButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLoginContext } from "../../context/loginContextProvider";
import { useNavigate } from "react-router";

export type HeaderProps = {
  back?: boolean;
};

export const DesktopHeader = ({ back }: HeaderProps) => {
  const { logout } = useLoginContext();
  const navigate = useNavigate();

  return (
    <Grid container>
      <Grid size={7}>
        <h1>
          {back && (
            <Button onClick={() => navigate(-1)}>
              <ArrowBackIosIcon
                fontSize="large"
                sx={{ textAlign: "right", verticalAlign: "middle" }}
              />
            </Button>
          )}
          Crypto Dashboard
        </h1>
      </Grid>
      <Grid size={2} sx={{}}>
        <PerformanceScreenButton />
      </Grid>
      <Grid size={2} sx={{}}>
        <AddProfileButton />
      </Grid>
      <Grid size={1} onClick={() => logout()} sx={{ textAlign: "right" }}>
        <a href="#">
          <h3>Logout</h3>
        </a>
      </Grid>
    </Grid>
  );
};
